import Page from "webPage/Page";
import Track from "../util/Track";
import Product from "util/Product";

Page.register("single-product", () => {

    let $similarTrack = $(".js-similar-awards-wrap");
    if ($similarTrack.length > 0) {
        let track = new Track($similarTrack, {
            classes: {
                block: "similar-awards",
            },
        });

        checkWindowWidth();

        $(window).on('resize', checkWindowWidth);

        function checkWindowWidth() {
            if ($(window).width() >= 960) {
                track.enabled = false;
            } else {
                track.enabled = true;
            }
        }
    }

    new Product($('.js-product'));

    upsellBanner();
    $(window).on('resize', upsellBanner);

    function upsellBanner(){
       let interval;

       if($(window).width() <= 760){
           if($('.js-upsell-banner').length > 0){
               let $upsellItem = $('.js-upsell-item');
               let total_items = $upsellItem.length;
               let i = 0;

               interval = setInterval(function(){
                   i++;
                   if(i >= total_items){
                       $upsellItem.eq(1).addClass('upsell-banner__item--next');
                       i = 0;
                   }

                   $upsellItem.removeClass('upsell-banner__item--active upsell-banner__item--next').eq(i).addClass('upsell-banner__item--active').next().addClass('upsell-banner__item--next');

                   if(i >= (total_items - 1)){
                       //Check to see if we're on the last one, then get the first item in the correct position.
                       $upsellItem.eq(0).addClass('upsell-banner__item--next');
                   }
               }, 2500);
           }
       } else {
           clearInterval(interval);
       }
    }
});


